import * as Location from 'expo-location';

import { fromPromise } from 'xstate';

import type { RequestLocationPermissionOutput } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const requestLocationPermissionActor = fromPromise<RequestLocationPermissionOutput>(
  async () => Location.requestForegroundPermissionsAsync(),
);
